export const en = {
  navbar: {
    home: "Home",
    about: "About",
    media: "Media", 
    gallery: "Gallery",
    repertoire: "Repertoire",
    contact: "Contact",
    youtube: "YouTube Channel"
  },
  hero: {
    title: "João Xavier",
    subtitle: " Pianist",
    discoverMore: "Discover More",
    getInTouch: "Get in Touch"
  },

  about: {
    title: "About me",
    biography: [
      "One of the most promising Portuguese pianists of his generation, João Xavier has captivated audiences across Portugal, Spain, Belgium, Italy and Russia. He has appeared in renowned venues such as Sala Suggia at Casa da Música (Porto), Gulbenkian Foundation Hall (Lisbon), Teatros del Canal (Madrid), the Great Hall of the Brussels Royal Conservatory, Centro Botín (Santander), and the Small, Rachmaninov and Great Halls of the Moscow State Tchaikovsky Conservatory.",
      "A prizewinner of numerous competitions, João has received distinctions such as 1st Prize at the Estoril Festival Competition (2021), 1st Prize at Prémio Jovens Músicos (2011), and 1st Prize at the Póvoa de Varzim, Florinda Santos and Santa Cecília Piano Competitions. In 2014, he was awarded 3rd Prize at the Jaén International Piano Competition.",
      "Born in Lousada, Portugal, João Xavier began his musical studies at the Vale do Sousa Conservatory, graduating in 2011 under Professor Luísa Ferreira. He later studied with Pedro Burmester at ESMAE (Porto), and also worked with Tania Achot-Haroutounian and Eliso Virsaladze at the Scuola di Musica di Fiesole (Florence). In 2020, he graduated with distinction from the Moscow State Tchaikovsky Conservatory under Eliso Virsaladze.",
      "He has performed in festivals such as Festival Internacional de Música da Póvoa de Varzim, Dias da Música (Centro Cultural de Belém), Cistermúsica (Alcobaça), and Midis-Minimes (Brussels).",
      "He has collaborated with conductors including Pedro Neves, Günther Neuhold, Nikolay Lalov, Anatoly Levin, Martin André, Stefan Blunier and Vasily Sinaisky.",
      "He completed his master's degree at the Koninklijk Conservatorium Brussel, studying with Aleksandar Madžar."
    ]
  },
  media: {
    title: "Media"
  },
  gallery: {
    title: "Gallery",
    nextImage: "Next image",
    previousImage: "Previous image"
  },
  repertoire: {
    title: "Repertoire for piano and orchestra"
  },
  contact: {
    title: "Contact",
    nameLabel: "Name",
    emailLabel: "Email", 
    messageLabel: "Message",
    submitBtn: "Send Message",
    submittingBtn: "Sending...",
    successMessage: "Message sent successfully!",
    successDescription: "Thank you for reaching out. I'll get back to you soon.",
    errorMessage: "Failed to send message",
    errorDescription: "Please try again or contact me directly at email.",
    waitMessage: "Please wait",
    waitDescription: "Please wait a few seconds before submitting again.",
    namePlaceholder: "Your full name",
    emailPlaceholder: "your.email@example.com", 
    messagePlaceholder: "Tell me about your project, event, or inquiry..."
  },
  footer: {
    copyright: `© ${new Date().getFullYear()} João Xavier`
  },
  language: {
    english: "EN",
    portuguese: "PT"
  },
  aria: {
    toggleMenu: "Toggle menu",
    scrollIndicator: "Scroll down",
    languageSwitcher: "Switch language"
  }
};